<template>
	<apexchart 
		:width="width" 
		:height="height" 
		:options="options" 
		:series="parsedData" 
	/>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
	name: "AttendanceReasonChart",
	props: {
		title: {
			type: String,
			default: "Motivo da Avaliação"
		},
		width: {
			type: [Number, String],
			default: "100%",
		},
		height: {
			type: [Number, String],
			default: "100%",
		},
		loading: {
			type: Boolean,
		},
		data: {
			type: Object,
			default: () => ({})
		}
	},
	components: {
		apexchart: VueApexCharts,
	},
	data: function () {
		return {};
	},
	computed: {
		parsedData(){
			if(!this.data) return [];
			if(Object.keys(this.data).length){
				return Object.values(this.data);
			}
			return []
		},
		options() {
			return {
				chart: {
					type: "pie",
				},
				title: {
					text: this.title,
					align: "center",
					style: {
						fontSize: "14px",
						fontWeight: "bold",
					},
				},
				colors: ["#28536B", "#C2948A", '#7EA8BE', "#673C4F", "#BBB193"],
				noData: {
					text: this.loading ? "Loading..." : "No Data",
				},
				labels: Object.keys(this.data || {}),
				legend: {
					position: "right",
					horizontalAlign: "center",
				},
				dataLabels: {
					enabled: true,
					style: {
						fontSize: '11px',
						fontWeight: 'bold',
						colors: ['#fff']
					},
					dropShadow: {
						enabled: true,
						top: 0,
						left: 0,
						blur: 1,
						opacity: 0.9,
						color: "black",
					},
					offset: 0,
					formatter: function (val, opts) {
						const value = opts.w.config.series[opts.seriesIndex];
						return val.toFixed(1) + '% (' + value + ')';
					}
				},
				plotOptions: {
					pie: {
						dataLabels: {
							offset: -15
						}
					}
				}
			};
		},
	},
};
</script>

<style lang="scss" scoped></style>